import * as React from 'react';

import Text from '../../styled/Text';
import { TextProps } from '../../styled/Text/component';

import styles from './styles';
function GalanoGrotesqueText(props: TextProps) {
  return <Text {...props} style={[styles.text, props.style]} />;
}

export default GalanoGrotesqueText;
